import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { http } from "@/lib/api";

export default function About() {
  const [site, setSite] = useState(null);
  useEffect(() => {
    http.get("/site").then((r) => setSite(r.data));
  }, []);

  return (
    <div className="pt-32 pb-24" data-testid="about-page">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20">
        <div className="mb-16">
          <div className="text-[10px] tracking-[0.35em] uppercase text-pink-blush mb-3">A closer look</div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-champagne leading-tight">
            About <span className="italic text-pink-hot">me</span>
          </h1>
        </div>

        <div className="grid lg:grid-cols-12 gap-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5"
          >
            <div className="lg:sticky lg:top-28">
              <div className="relative overflow-hidden rounded-md">
                <img
                  src={site?.about_image_base64 || "https://images.pexels.com/photos/14008895/pexels-photo-14008895.jpeg"}
                  alt="Layla"
                  className="w-full aspect-[3/4] object-cover"
                  data-testid="about-portrait"
                />
                <div className="absolute inset-0 ring-1 ring-pink-hot/20 pointer-events-none" />
              </div>
              <div className="glass-panel p-6 mt-6 rounded-md">
                <div className="text-[10px] tracking-[0.3em] uppercase text-pink-blush mb-4">The Essentials</div>
                <div className="divide-y divide-pink-hot/10">
                  {Object.entries(site?.stats || {}).map(([k, v]) => (
                    <div key={k} className="flex justify-between py-3">
                      <span className="text-xs tracking-[0.2em] uppercase text-rosegold/90">{k}</span>
                      <span className="text-sm font-display text-champagne">{v}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:col-span-7 space-y-8"
          >
            <div className="font-display italic text-3xl sm:text-4xl text-pink-hot leading-tight">
              “{site?.tagline || "Upscale companion. Modern muse."}”
            </div>
            <p className="text-lg text-champagne/85 leading-relaxed font-light">
              {site?.about_bio || "A curated companion for the refined gentleman."}
            </p>
            <div className="divider-gold" />
            <p className="text-base text-champagne/75 leading-relaxed whitespace-pre-line">
              {site?.about_long || ""}
            </p>

            <div className="grid sm:grid-cols-2 gap-6 pt-6">
              <div className="glass-panel p-6 rounded-md">
                <div className="text-[10px] tracking-[0.3em] uppercase text-pink-blush mb-2">Indulgences</div>
                <p className="text-sm text-champagne/80 leading-relaxed">Vintage champagne, live jazz, rainy nights in hotel suites, and the rustle of silk sheets.</p>
              </div>
              <div className="glass-panel p-6 rounded-md">
                <div className="text-[10px] tracking-[0.3em] uppercase text-pink-blush mb-2">Conversation</div>
                <p className="text-sm text-champagne/80 leading-relaxed">Art and architecture, old films, mid-century poetry, wicked humor, and whispered secrets.</p>
              </div>
            </div>

            <div className="pt-8">
              <Link
                to="/contact"
                className="inline-block px-8 py-3 bg-pink-hot text-white text-xs tracking-[0.3em] uppercase rounded-sm hover:bg-pink-glow glow-pink transition-all"
                data-testid="about-book-cta"
              >
                Request an evening
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
